import React from 'react';
import { Reveal } from './Reveal';
const testimonials = [{
  initials: 'ML',
  stars: 5,
  quote: 'Me gustó porque no se siente como otro material lleno de teoría. Son actividades concretas, fáciles de adaptar incluso cuando el día está complicado.',
  name: 'Mariana López',
  avatar: 'https://cdn.magicpatterns.com/uploads/uVcRB8r6RyynMF6chmN5P7/1.png'
}, {
  initials: 'MC',
  stars: 5,
  quote: 'Me sorprendió lo práctico que es. No es un PDF bonito nada más, realmente te guía paso a paso para aplicarlo.',
  name: 'Martín Calderón',
  avatar: 'https://cdn.magicpatterns.com/uploads/55TM7D4gveR9Y7bT3uj9Rt/5.png'
}, {
  initials: 'MA',
  stars: 5,
  quote: 'Me gustó porque baja a tierra algo que muchos padres sienten: quieren estar más presentes, pero no saben por dónde empezar.',
  name: 'Mateo Aguilar',
  avatar: 'https://cdn.magicpatterns.com/uploads/qconzk7vtsPfK3hygDuPpi/4.png'
}];
export function TestimonialsPrimary() {
  return <section aria-label="Testimonios" className="w-full bg-cream-100 py-16 sm:py-20" data-id="element-208" data-mp="tumpb708x7hk">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-209" data-mp="yruzakb8q57q">
        <div className="grid gap-5 md:grid-cols-3" data-id="element-210" data-mp="yuqzkfak95zc">
          {testimonials.map((t, i) => <Reveal key={t.initials} delay={i * 0.08} data-id="element-211" data-mp="13tu5e1yd7g8d" data-mpi={i}>
              <figure className="flex h-full flex-col rounded-3xl border border-bark-800/[0.08] bg-cream-50 p-6 shadow-sm" data-id="element-212" data-mp="18rvkycwl0xf3">
                <div className="flex items-center gap-3" data-id="element-213" data-mp="1crw8cn1nsiya">
                  <img src={t.avatar} alt={`Foto de ${t.name}`} loading="lazy" className="h-11 w-11 shrink-0 rounded-full bg-sage-100 object-cover" data-id="element-214" data-mp="1hr0mls3fx6vh" />
                  <span aria-label={`${t.stars} de 5 estrellas`} className="text-sm tracking-tight" data-id="element-215" data-mp="1rgk16lk4eekj">
                    {'⭐'.repeat(t.stars)}
                  </span>
                </div>
                <blockquote className="mt-4 flex-1 text-[0.95rem] leading-relaxed text-bark-600" data-id="element-216" data-mp="20ijilez1rko0">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-5 font-display text-sm font-semibold text-bark-800" data-id="element-217" data-mp="3sk327nohccup">
                  — {t.name}
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}